/*
 * Brancaia — Datenblatt (PDF) unter der Kaufzone (PDP).
 *
 * Quelle ist der eingebettete App-Block «Brancaia Product Sheets»
 * ([data-datenblatt-app]). Das Script übernimmt dessen Steuerung in die
 * Theme-Zeile, ohne Klassennamen der App zu kennen. Drei Quellen, in dieser
 * Reihenfolge:
 *   1. Links (a[href], option[value] mit URL, data-url-Attribute)
 *        -> Theme-Zeile mit echten Links, App-Block versteckt
 *   2. Auswahlfeld (<select> mit Vorlagen)
 *        -> Theme-Zeile mit einem Eintrag pro Option; Klick setzt die Option
 *           im App-Select, löst input/change aus und klickt einen allfälligen
 *           Button der App (Download/Öffnen). Die App erzeugt das PDF.
 *   3. Eigene Liste der App (Toggle + Einträge als Buttons/Links ohne URL)
 *        -> Theme-Zeile mit den Einträgen; Klick klickt den Eintrag der App
 *   4. Ein einzelner Button oder Link der App
 *        -> Theme-Zeile «Datenblatt (PDF)», Klick wird an die App weitergereicht
 * Darstellung: ein Eintrag -> Direktzeile; mehrere -> <details> mit Panel am
 * Link; Klick ausserhalb und Escape schliessen, Fokus zurück auf <summary>.
 * Keine Quelle erkannt -> App-Block bleibt sichtbar (Rückfallebene, per CSS
 * beruhigt); rendert er nichts, wird die ganze Zeile inklusive Haarlinie
 * versteckt.
 * Variantenwechsel (Quelle 1): Links aus detail.html des Variant-Picker-Events
 * (variant:change:<sectionId>:<productId>) neu übernehmen, kein Request.
 * GA4: file_download nur, wenn window.dataLayer im Shop vorhanden ist.
 */
(function () {
  'use strict';

  if (window.__brancaiaDatenblatt) return;
  window.__brancaiaDatenblatt = true;

  var URL_HINT = /\.pdf(\?|#|$)|\/apps\/|sheet|datenblatt|pdf/i;
  var PLACEHOLDER = /^(bitte|please|select|wählen|waehlen|choose|auswahl|—|-|…|\.\.\.)/i;

  function text(el) {
    return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function isUrl(value) {
    var v = (value || '').trim();
    if (!v || v === '#' || /^(javascript|mailto|tel|data):/i.test(v)) return false;
    return /^(https?:)?\/\//i.test(v) || v.charAt(0) === '/' || /\.pdf(\?|#|$)/i.test(v);
  }

  function fileName(url) {
    try {
      var path = new URL(url, window.location.href).pathname;
      return decodeURIComponent(path.split('/').filter(Boolean).pop() || '');
    } catch (e) {
      return '';
    }
  }

  /* Quelle 1: echte Link-Ziele im App-Block (dedupliziert, Reihenfolge erhalten). */
  function collectLinks(scope) {
    var out = [];
    var seen = {};
    var nodes = scope.querySelectorAll(
      'a[href], option[value], [data-url], [data-href], [data-pdf-url], [data-sheet-url], [data-download-url]'
    );
    Array.prototype.forEach.call(nodes, function (el) {
      var url =
        el.getAttribute('href') ||
        el.getAttribute('data-url') ||
        el.getAttribute('data-href') ||
        el.getAttribute('data-pdf-url') ||
        el.getAttribute('data-sheet-url') ||
        el.getAttribute('data-download-url') ||
        el.getAttribute('value');
      if (!isUrl(url)) return;
      url = url.trim();
      if (seen[url]) return;
      seen[url] = true;
      out.push({ url: url, label: text(el) });
    });
    var pdfish = out.filter(function (s) {
      return URL_HINT.test(s.url);
    });
    return pdfish.length ? pdfish : out;
  }

  /* Quelle 2: Auswahlfeld der App. Platzhalter-Optionen (leer, disabled,
     «Bitte wählen», Label der Zeile) werden übersprungen. */
  function collectSelect(scope, labels) {
    var select = scope.querySelector('select');
    if (!select) return null;
    var options = [];
    Array.prototype.forEach.call(select.options, function (opt) {
      var value = opt.value;
      var label = text(opt);
      if (opt.disabled || value === '' || value == null) return;
      if (PLACEHOLDER.test(label)) return;
      if (label === labels.app || label === labels.link) return;
      options.push({ value: value, label: label });
    });
    if (!options.length) return null;
    return { select: select, options: options };
  }

  /* Button der App neben einem Select (Download/Öffnen); null, wenn keiner da ist. */
  function appButton(scope) {
    var candidates = scope.querySelectorAll('button, input[type="submit"], input[type="button"], a[role="button"]');
    for (var i = 0; i < candidates.length; i++) {
      if (!candidates[i].disabled) return candidates[i];
    }
    return null;
  }

  /* Quelle 3: eigene Liste der App (Toggle-Button + Einträge als Buttons/Links
     ohne echte URL). Die Einträge werden direkt angeklickt, auch wenn die
     Liste der App geschlossen ist. */
  function collectListControls(scope) {
    var nodes = scope.querySelectorAll(
      'li button, li a, [role="menuitem"], [role="option"], [role="menu"] button, [role="listbox"] button'
    );
    var out = [];
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.disabled || el.getAttribute('aria-disabled') === 'true') return;
      if (isUrl(el.getAttribute('href'))) return;
      if (out.indexOf(el) !== -1) return;
      out.push(el);
    });
    return out.length ? out : null;
  }

  function isToggle(el) {
    return el.hasAttribute('aria-haspopup') || el.hasAttribute('aria-expanded') || el.hasAttribute('aria-controls');
  }

  /* Quelle 4: genau ein sichtbarer Button/Link der App ohne echte URL, der
     keine eigene Liste öffnet. */
  function collectSingleControl(scope) {
    var controls = scope.querySelectorAll('button, input[type="submit"], input[type="button"], a, [role="button"]');
    var usable = Array.prototype.filter.call(controls, function (el) {
      return !el.disabled && (el.offsetParent !== null || el.getClientRects().length > 0);
    });
    if (usable.length !== 1) return null;
    if (isToggle(usable[0])) return null;
    if (scope.querySelector('ul, ol, [role="menu"], [role="listbox"], details')) return null;
    return usable[0];
  }

  /* Hat der App-Block überhaupt sichtbaren Inhalt? (Scripts/Styles zählen nicht.) */
  function hasContent(scope) {
    var clone = scope.cloneNode(true);
    Array.prototype.forEach.call(clone.querySelectorAll('script, style, template'), function (n) {
      n.parentNode.removeChild(n);
    });
    if ((clone.textContent || '').trim() !== '') return true;
    return !!clone.querySelector('a, button, select, input, details, img, svg, iframe');
  }

  /* Rechteck des ersten bzw. letzten sichtbaren Textknotens eines Elements
     (Range-Messung), damit Abstände von Text zu Text verglichen werden. */
  function textRect(el, last) {
    if (!el || !document.createTreeWalker) return null;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    var found = null;
    while ((node = walker.nextNode())) {
      if (!/\S/.test(node.nodeValue)) continue;
      var parent = node.parentElement;
      if (!parent || parent.closest('script, style, template, [hidden]')) continue;
      var range = document.createRange();
      range.selectNodeContents(node);
      var rect = range.getBoundingClientRect();
      if (!rect.height) continue;
      found = rect;
      if (!last) break;
    }
    return found;
  }

  function init(root) {
    if (root.__datenblattInit) return;
    root.__datenblattInit = true;

    var ui = root.querySelector('[data-datenblatt-ui]');
    var app = root.querySelector('[data-datenblatt-app]');
    if (!ui || !app) return;

    var labels = {};
    try {
      labels = JSON.parse(root.querySelector('[data-datenblatt-config]').textContent).labels || {};
    } catch (e) {
      labels = {};
    }
    labels.link = labels.link || 'Datenblatt (PDF)';
    labels.incl = labels.incl || 'Datenblatt inkl. Preis';
    labels.excl = labels.excl || 'Datenblatt exkl. Preis';
    labels.app = labels.app || '';

    var iconTpl = root.querySelector('[data-datenblatt-icon]');
    var chevronTpl = root.querySelector('[data-datenblatt-chevron]');
    var current = [];

    function fromTemplate(tpl) {
      if (!tpl) return document.createDocumentFragment();
      return document.importNode(tpl.content, true);
    }

    /* Vorlagen-Label: nur den Unterschied nennen, nie den Weinnamen. */
    function itemLabel(raw, index, total) {
      var r = (raw || '').toLowerCase();
      if (/exkl|excl|ohne preis|without price|sans prix|senza prezzo|sin precio/.test(r)) return labels.excl;
      if (/inkl|incl|mit preis|with price|prix inclus|con prezzo|con precio/.test(r)) return labels.incl;
      if (raw && raw !== labels.app && raw !== labels.link) return raw;
      return total > 1 ? labels.link + ' ' + (index + 1) : labels.link;
    }

    /* Ein Eintrag: echter Link (url) oder Weiterreichung an die App (activate). */
    function makeAction(className, sheet, index, label, ariaLabel) {
      var el;
      if (sheet.url) {
        el = document.createElement('a');
        el.href = sheet.url;
        el.target = '_blank';
        el.rel = 'noopener';
        el.setAttribute('data-file-name', fileName(sheet.url));
      } else {
        el = document.createElement('button');
        el.type = 'button';
      }
      el.className = className;
      el.setAttribute('data-datenblatt-link', '');
      el.setAttribute('data-index', String(index));
      el.setAttribute('data-sheet-label', label);
      if (ariaLabel) el.setAttribute('aria-label', ariaLabel);
      return el;
    }

    /* Zeile im Raster der Häkchen-Zeilen darüber (Gratis Versand, Abholung):
       gleiche Klassen wie dort (store-availability, store-availability__info),
       damit Icon-Position, Textanfang und Schriftgrösse identisch sind. */
    function buildRow(container, label, withChevron) {
      container.classList.add('store-availability');
      var iconWrap = document.createElement('element-icon');
      iconWrap.className = 'datenblatt__icon-wrap';
      iconWrap.appendChild(fromTemplate(iconTpl));
      container.appendChild(iconWrap);
      var info = document.createElement('span');
      info.className = 'store-availability__info datenblatt__text';
      var labelEl = document.createElement('span');
      labelEl.className = 'datenblatt__label';
      labelEl.textContent = label;
      info.appendChild(labelEl);
      if (withChevron) info.appendChild(fromTemplate(chevronTpl));
      container.appendChild(info);
      return info;
    }

    /* Panel am Textanfang ausrichten (der Text sitzt rechts vom Icon). */
    function alignPanel(details) {
      var panel = details.querySelector('.datenblatt__panel');
      var textEl = details.querySelector('.datenblatt__text');
      if (!panel || !textEl) return;
      var offset = textEl.getBoundingClientRect().left - details.getBoundingClientRect().left;
      panel.style.left = Math.max(0, Math.round(offset)) + 'px';
    }

    function render(sheets) {
      if (!sheets.length) return false;
      current = sheets;
      var fresh = document.createDocumentFragment();

      if (sheets.length === 1) {
        var single = makeAction('datenblatt__link', sheets[0], 0, labels.link, labels.aria);
        buildRow(single, labels.link, false);
        fresh.appendChild(single);
      } else {
        var details = document.createElement('details');
        details.className = 'datenblatt__disclosure';
        details.setAttribute('data-datenblatt-disclosure', '');

        var summary = document.createElement('summary');
        summary.className = 'datenblatt__link';
        buildRow(summary, labels.link, true);
        details.appendChild(summary);

        var panel = document.createElement('div');
        panel.className = 'datenblatt__panel';
        sheets.forEach(function (sheet, index) {
          var label = itemLabel(sheet.label, index, sheets.length);
          var item = makeAction('datenblatt__item', sheet, index, label, null);
          var itemText = document.createElement('span');
          itemText.textContent = label;
          item.appendChild(itemText);
          item.appendChild(fromTemplate(iconTpl));
          panel.appendChild(item);
        });
        details.appendChild(panel);
        details.addEventListener('toggle', function () {
          if (details.open) alignPanel(details);
        });
        fresh.appendChild(details);
      }

      ui.innerHTML = '';
      ui.appendChild(fresh);
      ui.hidden = false;
      app.hidden = true;
      root.hidden = false;
      scheduleSpacing();
      return true;
    }

    /* Vertikaler Abstand: Text-zu-Text-Abstand zur Zeile darüber (Abholung)
       gleich dem Abstand zwischen «Gratis Versand» und «Abholbereit». Wird
       gemessen statt geschätzt, weil der Abholblock asynchron nachlädt und
       unter seinem Link unsichtbaren Raum haben kann. */
    function syncSpacing() {
      if (ui.hidden) return;
      var label = ui.querySelector('.datenblatt__label');
      if (!label) return;
      var section = (root.parentElement && root.parentElement.closest('[data-section-id]')) || document;
      var ship = section.querySelector('.product__free-shipping:not([hidden])');
      var pickup = section.querySelector('store-availability .store-availability');
      var above = pickup || ship;
      if (!above) {
        root.style.marginTop = '';
        return;
      }
      var reference = 28;
      if (ship && pickup) {
        var shipBottom = textRect(ship, true);
        var pickupTop = textRect(pickup, false);
        if (shipBottom && pickupTop) {
          var measured = pickupTop.top - shipBottom.bottom;
          if (measured > 0 && measured < 120) reference = measured;
        }
      }
      var aboveBottom = textRect(above, true);
      var ownTop = textRect(label, false);
      if (!aboveBottom || !ownTop) return;
      var current = ownTop.top - aboveBottom.bottom;
      var margin = parseFloat(getComputedStyle(root).marginTop) || 0;
      var next = Math.round(margin + (reference - current));
      if (Math.abs(reference - current) < 0.5) return;
      root.style.marginTop = next + 'px';
    }

    var spacingTimer = null;
    function scheduleSpacing() {
      clearTimeout(spacingTimer);
      spacingTimer = setTimeout(syncSpacing, 60);
    }

    /* Alle Quellen der Reihe nach probieren. */
    function adopt() {
      var links = collectLinks(app);
      if (links.length) return render(links);

      var sel = collectSelect(app, labels);
      if (sel) {
        return render(
          sel.options.map(function (opt) {
            return {
              label: opt.label,
              activate: function () {
                var select = sel.select;
                select.value = opt.value;
                Array.prototype.forEach.call(select.options, function (o) {
                  o.selected = o.value === opt.value;
                });
                select.dispatchEvent(new Event('input', { bubbles: true }));
                select.dispatchEvent(new Event('change', { bubbles: true }));
                var button = appButton(app);
                if (button) button.click();
              }
            };
          })
        );
      }

      var listControls = collectListControls(app);
      if (listControls) {
        return render(
          listControls.map(function (el) {
            return {
              label: text(el),
              activate: function () {
                el.click();
              }
            };
          })
        );
      }

      var control = collectSingleControl(app);
      if (control) {
        return render([
          {
            label: text(control),
            activate: function () {
              control.click();
            }
          }
        ]);
      }

      return false;
    }

    /* Rückfallebene: App-Block zeigen; ohne Inhalt die ganze Zeile verstecken. */
    function fallback() {
      ui.hidden = true;
      app.hidden = false;
      root.hidden = !hasContent(app);
    }

    function closeOpen(returnFocus) {
      var open = ui.querySelector('details[open]');
      if (!open) return false;
      open.removeAttribute('open');
      if (returnFocus) {
        var summary = open.querySelector('summary');
        if (summary) summary.focus();
      }
      return true;
    }

    function track(link) {
      if (!window.dataLayer || typeof window.dataLayer.push !== 'function') return;
      window.dataLayer.push({
        event: 'file_download',
        file_name: link.getAttribute('data-file-name') || link.href || '',
        file_extension: 'pdf',
        product_title: root.getAttribute('data-product-title') || '',
        sheet_label: link.getAttribute('data-sheet-label') || ''
      });
    }

    root.addEventListener('click', function (event) {
      var link = event.target.closest('[data-datenblatt-link]');
      if (!link) return;
      track(link);
      var sheet = current[parseInt(link.getAttribute('data-index'), 10)];
      if (sheet && typeof sheet.activate === 'function') {
        event.preventDefault();
        sheet.activate();
      }
      if (link.classList.contains('datenblatt__item')) closeOpen(false);
    });

    document.addEventListener('click', function (event) {
      var open = ui.querySelector('details[open]');
      if (!open || open.contains(event.target)) return;
      open.removeAttribute('open');
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      if (closeOpen(true)) event.stopPropagation();
    });

    /* Erste Darstellung; rendert die App erst später (JS), nachziehen. */
    if (!adopt()) {
      fallback();
      if ('MutationObserver' in window) {
        var observer = new MutationObserver(function () {
          if (adopt()) {
            observer.disconnect();
          } else {
            fallback();
          }
        });
        observer.observe(app, { childList: true, subtree: true, attributes: true, characterData: true });
        setTimeout(function () {
          observer.disconnect();
        }, 15000);
      }
    }

    /* Abstand nachführen: Abholblock lädt nach, Schriften laden, Breite ändert sich. */
    window.addEventListener('resize', scheduleSpacing);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleSpacing);
    if ('ResizeObserver' in window) {
      var block = (root.parentElement && root.parentElement.closest('[data-section-id]')) || root.parentElement;
      if (block) new ResizeObserver(scheduleSpacing).observe(block);
    }

    /* Variantenwechsel: echte Links aus dem neu gerenderten Section-HTML übernehmen. */
    var eventName = 'variant:change:' + root.getAttribute('data-section-id') + ':' + root.getAttribute('data-product-id');
    document.addEventListener(eventName, function (event) {
      var detail = event.detail || {};
      if (detail.loading || !detail.html || typeof detail.html.querySelector !== 'function') return;
      var next = detail.html.querySelector('[data-datenblatt-app]');
      if (!next) return;
      var links = collectLinks(next);
      if (links.length) {
        closeOpen(false);
        render(links);
      }
      setTimeout(scheduleSpacing, 400);
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-datenblatt]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  /* Theme-Editor: Section neu geladen. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();
